// Packages
import sdk from '@nuinalp/cms-sdk-js';

// Store
import { useUserStore } from '~/store/user';

// SDK
import SDK from './index';
import type services from './index';

export default class User {
  private store = useUserStore;

  constructor (
    private $sdk: typeof sdk,
    private $service: InstanceType<typeof services>
  ) {};

  public async info() {
    const store = this.store();

    const res = await this.$sdk.user.me();
    store.setInfo(res);

    return res;
  }
}